import React from 'react'
import styles from 'modules/Services/Access/List/network-account-access.module.scss'
import { Grid, Icon } from 'gu-ui-kit'

const UserIcon = () => {
  return (
    <Grid
      alignItems="center"
      justifyContent="center"
      className={styles['accesses-list__icon']}
    >
      <Icon name="user" size={'m'} color={'Interface-Eighth'} />
    </Grid>
  )
}

export default UserIcon
